import {
    Button,
    Card,
    Switch,
    Table,
    Tooltip,
    Form,
    Input,
    Modal,
    Row,
    Col,
    DatePicker,
  } from "antd";
  import moment from "moment";
  import React, { useContext, useEffect, useState } from "react";
  import Plus from "../../assets/images/plus.svg";
  import DeleteModal from "../../components/DeleteModal";
  import apiPath from "../../constants/apiPath";
  import {
    BlockCustomerReasons,
    DeleteCustomerReasons,
  } from "../../constants/reasons";
  import { AppStateContext } from "../../context/AppContext";
  import lang from "../../helper/langHelper";
  import { Severty, ShowToast } from "../../helper/toast";
  import useDebounce from "../../hooks/useDebounce";
  import useRequest from "../../hooks/useRequest";
  import { useNavigate } from "react-router";
import { UndoOutlined } from "@ant-design/icons";
  
  const { RangePicker } = DatePicker;
  
  function Index() {
    const heading = lang("Order") + " " + lang("Management");
    const { setPageHeading } = useContext(AppStateContext);
    const Search = Input.Search;
    const sectionName = lang("Order");
    const urlParams = new URLSearchParams(window.location.search);
    const path = urlParams.get("status");
  
    const api = {
      addEdit: apiPath.addEditCustomer,
      list: apiPath.order,  
    };
  
    const [searchText, setSearchText] = useState("");
    const { request } = useRequest();
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [visible, setVisible] = useState(false);
    const [selected, setSelected] = useState();
    const [showDelete, setShowDelete] = useState(false);
    const [showStatus, setShowStatus] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const debouncedSearchText = useDebounce(searchText, 300);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [rowFilter, setRowFilter] = useState({});

    const onSearch = (e) => {
      setSearchText(e.target.value);
      setPagination({ current: 1, pageSize: 10 });
    };
  
    const onDelete = (id) => {
      request({
        url: api.delete + "/" + id,
        method: "DELETE",
        onSuccess: (data) => {
          setLoading(false);
          setRefresh((prev) => !prev);
          ShowToast(data.message, Severty.SUCCESS);
        },
        onError: (error) => {
          setLoading(false);
          ShowToast(error, Severty.ERROR);
        },
      });
    };
  
    const handleChangeStatus = (id, message) => {
      request({
        url: api.list + "/status/" + id,
        method: "PUT",
        data: { message },
        onSuccess: (data) => {
          setLoading(false);
          setRefresh((prev) => !prev);
          ShowToast(data.message, Severty.SUCCESS);
        },
        onError: (error) => {
          console.log(error);
          setLoading(false);
          ShowToast(error, Severty.ERROR);
        },
      });
    };
  
    const columns = [
      {
        title: "order Id",
        dataIndex: "order_id",
        key: "order_id",
        render: (_, { order_id }) => (
          <span color="white">#{order_id || "-"}</span>
        ),
      },
      {
        title: "User Name",
        render: (_, { user_id }) => {
          return user_id?.name ? user_id?.name : "-";
        },
      },
      // Table.EXPAND_COLUMN,
      // {
      //   title: "Product Name",
      //   dataIndex: "product_id",
      //   key: "product_id",
      //   width: 200,
      //   // sorter: (a, b) => a.name?.localeCompare(b.name),
      //   render: (_, { product_id }) => {
      //     return product_id ? <div>
      //       {product_id?.products?.name}
      //     </div> : "-";
      //   },
      // },
     

     
      {
        title: "quantity",
        render: (_, { quantity }) => {
          return quantity ? quantity : "-";
        },
      },
      {
        title: "total amount",
        render: (_, { total_amount }) => {
          return total_amount ? total_amount : "-";
        },
      },
      {
        title: "status",
        render: (_, { status }) => {
          return status ? status : "-";
        },
      },
      
      {
        title: "Order On",
        key: "created_at",
        dataIndex: "created_at",
        render: (_, { created_at }) => {
          return moment(created_at).format("ll");
        },
      },
      
      // {
      //   title: "Action",
      //   fixed: "right",
      //   key: "action",
      //   render: (_, record) => {
      //     return (
      //       <div div className="d-flex justify-contenbt-start">
      //         <Tooltip title={"Edit"} color={"purple"} key={"edit"}>
      //           <Button
      //             className="edit-cls btnStyle primary_btn"
      //             onClick={() => {
      //               setSelected(record);
      //               setVisible(true);
      //             }}
      //           >
      //             <i style={{ color: "fff" }} class="far fa-edit"></i>
      //           </Button>
      //         </Tooltip>
  
      //         <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
      //           <Button
      //             className="btnStyle deleteDangerbtn"
      //             onClick={() => {
      //               setSelected(record);
      //               setShowDelete(true);  
      //             }}
      //           >
      //             <i
      //               style={{ fontSize: "small", color: "fff" }}
      //               class="fa fa-light fa-trash"
      //             ></i>
      //           </Button>
      //         </Tooltip>
      //       </div>
      //     );
      //   },
      // },
    ];
  
    useEffect(() => {
      setLoading(true);
      fetchData({ ...pagination, current: 1 });
    }, [refresh, debouncedSearchText, startDate, endDate]);
  
    useEffect(() => {
      setPageHeading(heading);
    }, [setPageHeading]);
  
    const fetchData = (pagination, filters) => {
      const filterActive =    filters  ?  filters.is_active : rowFilter ?   rowFilter.is_active :   null
      const filterUsed =      filters  ?  filters.is_used :   rowFilter ?   rowFilter.is_used :     null
      const filterExpired =   filters  ?  filters.is_expired : rowFilter ?   rowFilter.is_expired : null
  
      request({
        url:
          api.list +
          `?status=${filterActive ? filterActive.join(",") : ""}&is_used=${filterUsed 
            ? filterUsed.join(",") : ""}&is_expired=${filterExpired
            ? filterExpired.join(",") : ""}&page=${ pagination 
            ? pagination.current : 1}&pageSize=${ pagination 
            ? pagination.pageSize : 10 }&search=${debouncedSearchText}&start_date=${startDate 
            ? startDate : "" }&end_date=${endDate ? endDate : ""}${path ? `&status=1` : ""}`,
        method: "GET",
        onSuccess: ({data}) => {
          setLoading(false);
          setList(data.data);
          setPagination((prev) => ({
            ...prev,
            current: pagination.current,
            total: data?.total,
          }));
        },
        onError: (error) => {
          setLoading(false);
          ShowToast(error, Severty.ERROR);
        },
      });
    };
  
    const handleChange = (pagination, filters) => {
      fetchData(pagination, filters);
      setRowFilter(filters)
  }
  
  
  
    return (
      <>
        <div className="tabled productCaralogue">
          <Row gutter={[24, 0]}>
            <Col xs="24" xl={24}>
              <Card
                bordered={false}
                className="criclebox tablespace mb-24"
                title={"Order List"}
                extra={
                  <>
                     {/* <div className="role-wrap">
              <Select
                width="110px"
                placeholder="Status"
                value={orderStatus}
                filterOption={false}
                options={Status.map((item) => ({
                  value: item.value,
                  label: item.label,
                }))}
                onChange={(value) => setOrderStatus(value)}
              />
            </div> */}
            <div className="w-100 text-head_right_cont">
              {/* <RangePicker disabledDate={(current) => current.isAfter(Date.now())} onChange={handleChangeDate} /> */}
              <div className="pageHeadingSearch">
                <Input.Search
                  className="searchInput"
                  placeholder={"Search by Customer Name or Order ID"}
                  value={searchText}
                  onChange={onSearch}
                  allowClear
                />
              </div>
              <Button
                onClick={() => {
                  setSearchText("");
                 
                }}
                type="primary"
                icon={<UndoOutlined />}
              >
                Reset
              </Button>
            </div>
          </>
          }
                
              >
                <div className="table-responsive customPagination">
                  <Table
                    loading={loading}
                    columns={columns}
                    dataSource={list}
                    pagination={{
                      defaultPageSize: 10,
                      responsive: true,
                      total: pagination.total,
                    }}
                    onChange={handleChange}
                    className="ant-border-space"
                    // expandable={{
                    //   expandedRowRender: (record) => (
                    //     <div className="sec-add-table">
                    //       <p style={{ margin: 0 }}>
                    //         <span>{"Attributes"} :</span>{" "}
                    //         {record?.product_variant?.attribute?.length ? (
                    //           record?.product_variant?.attribute?.map((item)=>(
                    //             <span className="cap">
                    //             [
                    //             {item?.name} - {item?.value}
                    //             ]{" "}
                    //           </span>
                    //           ))
                            
                    //         ) : (
                    //           "No Values"
                    //         )}
                    //       </p>
                    //     </div>
                    //   ),
                    // }}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
  
        {showDelete && (
          <DeleteModal
            title={lang("Delete Order")}
            subtitle={lang(`Are you sure you want to delete this Order?`)}
            show={showDelete}
            hide={() => {
              setShowDelete(false);
              setSelected();
            }}
            onOk={() => onDelete(selected?._id)}
            reasons={DeleteCustomerReasons}
          />
        )}
      </>
    );
  }
  
  export default Index;
  